import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "FULL SPECTRUM HOUSE",
  "BAHAMAS HOUSE PIONEER",
  "LOUNGE TO PEAK TIME",
  "TAKE THE JOURNEY",
  "MOVE THE CROWD",
];

export const ScrollMarquee = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`py-6 border-y ${
      dark ? "border-white/10 bg-[#003399]" : "border-white/10 bg-black"
    }`}
  >
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-2xl md:text-4xl uppercase text-[#F2F2F2] mx-8 tracking-tight">
            {t}
          </span>
          <span className="text-[#F2F2F2]/40 text-2xl md:text-4xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default ScrollMarquee;
